import React, {useEffect, useState} from "react"
import {FormControlLabel, Grid, Switch} from "@mui/material"
import {useMuseumSelectorState} from "../../../app/museum-selector/museumSelectorContext"
import {useAxiosBpn} from "../../../app/axios"
import useCustomSnackbar from "../../../app/components/useCustomSnackbar"
import {lowerFirst} from "lodash"
import {ProgressIndicator} from "../../../app/ProgressIndicator"
import {useBaseTranslation} from "../../../app/baseTranslationContext"
import Typography from "@mui/material/Typography"
import RubicInputFields from "./RubicInputFields"

const RubicSettings = ({umbrellaSettings, museumSettings, getMuseumSettings}) => {
    const t = useBaseTranslation()
    const {selectedMuseum, umbrellaId, umbrellaName} = useMuseumSelectorState()
    const [overrideUmbrellaSetting, setOverrideUmbrellaSetting] = useState(false)
    const snackbar = useCustomSnackbar()

    const [
        {
            data: umbrellaPutData,
            error: umbrellaPutError,
        }, putUmbrellaMuseumSettings,
    ] = useAxiosBpn({method: "PUT"}, {manual: true})

    const [
        {
            data: museumPutData,
            loading: museumPutLoading,
            error: museumPutError,
        }, putMuseumSettings,
    ] = useAxiosBpn({method: "PUT"}, {manual: true})

    useEffect(() => {
        setOverrideUmbrellaSetting(!!museumSettings?.rubicApiUrl)
    }, [museumSettings])

    useEffect(() => {
        if (umbrellaPutData) {
            snackbar.showSuccess(`${t("mailchimpSettings")} for ${umbrellaName} ${lowerFirst(t("updated"))}`)
            getMuseumSettings()
        }
        if (museumPutData) {
            snackbar.showSuccess(`${t("rubicSettings")} for ${selectedMuseum?.name} ${lowerFirst(t("updated"))}`)
            getMuseumSettings()
        }
    }, [selectedMuseum, museumPutData, t, umbrellaName, snackbar, getMuseumSettings, umbrellaPutData])

    useEffect(() => {
        if (museumPutError) {
            snackbar.showError(t(museumPutError.message))
        }
        if (umbrellaPutError) {
            snackbar.showError(t(umbrellaPutError.message))
        }
    }, [museumPutError, t, snackbar, umbrellaPutError])

    const handleUmbrellaUrlSave = (rubicApiUrl) => {
        const id = umbrellaSettings?.museumId ? umbrellaSettings.museumId : umbrellaId
        putUmbrellaMuseumSettings({
            url: `museum_settings/${id}`,
            data: {
                ...umbrellaSettings,
                museumName: umbrellaName,
                rubicApiUrl: rubicApiUrl,
            },
        })
    }

    const handleMuseumUrlSave = (rubicApiUrl) => {
        const id = museumSettings?.museumId ? museumSettings.museumId : selectedMuseum?.id
        const updatedMuseumSettings = {
            ...museumSettings,
            museumName: selectedMuseum?.name,
        }

        if (!overrideUmbrellaSetting) {
            delete updatedMuseumSettings.rubicApiUrl
        } else {
            updatedMuseumSettings.rubicApiUrl = rubicApiUrl
        }

        putMuseumSettings({
            url: `museum_settings/${id}`,
            data: updatedMuseumSettings,
        })
    }

    const getOverrideSwitcherLabel = () => {
        return (
            <>
                <Typography>{t("ownRubicApiUrlForMuseum")}</Typography>
                <Typography variant="subtitle1"
                            color="textSecondary">{t("ownUrlForMuseumHelperText")}</Typography>
            </>
        )
    }

    const handleToggleOverrideUmbrellaSettings = () => {
        setOverrideUmbrellaSetting(!overrideUmbrellaSetting)
    }

    return (
        <>
            <Grid container
                  spacing={3}
                  direction="column">
                {museumPutLoading
                 ? <ProgressIndicator/>
                 : <>

                     <Grid container
                           item
                           xs={12}>
                         <RubicInputFields handleSaveRubicSettings={handleUmbrellaUrlSave}
                                           museumSettings={umbrellaSettings}
                                           isUmbrellaFields={true}
                                           readonly={false}/>
                         {selectedMuseum?.type === "museum" && (<>
                             <Grid item>
                                 <FormControlLabel label={getOverrideSwitcherLabel()}
                                                   control={
                                                       <Switch checked={overrideUmbrellaSetting}
                                                               onChange={() => handleToggleOverrideUmbrellaSettings()}/>
                                                   }/>
                             </Grid>
                             <RubicInputFields handleSaveRubicSettings={handleMuseumUrlSave}
                                               museumSettings={museumSettings}
                                               readonly={!overrideUmbrellaSetting}/></>)}

                     </Grid>
                 </>
                }
            </Grid>
        </>
    )
}

export default RubicSettings